
import classes from "./Icons.module.css"

const Calendar = ({ width, color }) => {

    return <svg className={classes.Calendar} xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18" fill="none">
        <path d="M12.5556 3.33301H2.44444C1.6467 3.33301 1 3.97971 1 4.77745V14.8886C1 15.6863 1.6467 16.333 2.44444 16.333H12.5556C13.3533 16.333 14 15.6863 14 14.8886V4.77745C14 3.97971 13.3533 3.33301 12.5556 3.33301Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.3892 1.88867V4.77756" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.61084 1.88867V4.77756" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M1 7.66699H14" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
}

export default Calendar;